module.exports = __webpack_public_path__ + "img/renke-2.365c0f8c.png";